import { Fragment } from "react";
import "./profile.scss";
import Form, { GroupItem, SimpleItem } from "devextreme-react/form";
import { useSelector } from "react-redux";
import { userSelector } from "../../redux/auth";
import { imageUrl } from "../../services/urls";

export default function Profile() {
  const user = useSelector(userSelector);

  return (
    <Fragment>
      <h2 className={"content-block"}>Profile</h2>
      <div className={"content-block dx-card responsive-paddings"}>
        <div className={"form-avatar"}>
          <img alt={""} src={imageUrl + user?.ProfileImage} />
        </div>
        <div className={"content-block dx-card responsive-paddings"}>
          <Form
            id={"form"}
            formData={user}
            labelLocation={"top"}
            colCountByScreen={colCountByScreen}
          >
            <GroupItem>
              <SimpleItem
                editorOptions={{ disabled: true }}
                dataField={"Name"}
              />
              <SimpleItem
                editorOptions={{ disabled: true }}
                dataField={"Surname"}
              />
              <SimpleItem
                editorOptions={{ disabled: true }}
                dataField={"Email"}
              />
              <SimpleItem
                editorOptions={{ disabled: true }}
                dataField={"PhoneNumber"}
              />
            </GroupItem>
          </Form>
        </div>
      </div>
    </Fragment>
  );
}

const colCountByScreen = {
  xs: 1,
  sm: 2,
  md: 3,
  lg: 4,
};
